import { useState,useEffect } from "react";
import { useParams,useLocation,Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Heading from "../component/ui/Heading.js";
import Loader from "../component/ui/Loader.js";
import ThumbnailCard from "../component/ThumbnailCard/ThumbnailCard.js";
import MediaMainBG from "../component/MediaMainBG/MediaMainBG.js";
import PreviewImage from "../component/previews/PreviewImage.js";
import Button from "../component/ui/Button.js";
import { skipToken } from "@reduxjs/toolkit/query";


export default function Playlist() {
  const { id } = useParams();
  const title = id;
  const videos = useSelector((state) => state.video.byKey["playlist_" + title] || [])?.video;
  const videosTmp = useSelector((state) => state.video.byKey["playlist_" + title] || []);

  let coverImage = undefined;
  if (videos && videos?.coverImage) {
    coverImage = videos?.coverImage;
  }
  let titleHedear = null;
  if (videosTmp && videosTmp?.title) {
    titleHedear = videosTmp?.title;
  }
  return (
    <div className="flex h-full">
      <div className="space-y-8 flex-1 p-8">
        <Heading>
          {titleHedear || "Categorie"}
        </Heading>
        <MediaMainBG type="movies" coverImage={coverImage} />
<div className="flex flex-wrap gap-6 justify-start content-start">
          {videos.videos.map((video) => (
            <div
              key={video.videoId}
              style={{ flexBasis: 300 }}
              className="block flex-shrink-0 rounded-lg overflow-x-hidden max-w-[350px] w-full"
            >
              <Link
                to={`/videos/${video.id}`}
                state={{ video: video }}
                className="block"
                style={{ height: 200 }}
              >
                <PreviewImage media={video} type={'tv'} hud={true} />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
